import { render, staticRenderFns } from "./Ihbarname891HacizForm.vue?vue&type=template&id=55666b04&scoped=true"
import script from "./Ihbarname891HacizForm.vue?vue&type=script&lang=ts"
export * from "./Ihbarname891HacizForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55666b04",
  null
  
)

export default component.exports